module.exports = __webpack_public_path__ + "static/media/m_b_35.da3ac392.png";